import { render } from "./TeachingVocabulary.vue?vue&type=template&id=17996fae&scoped=true"
import script from "./TeachingVocabulary.vue?vue&type=script&lang=js"
export * from "./TeachingVocabulary.vue?vue&type=script&lang=js"

import "./TeachingVocabulary.vue?vue&type=style&index=0&id=17996fae&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-17996fae"

export default script